import { useMemo } from 'react';
import { SbefScopeGroupKey } from '@shared/construction/sbef-custom-groups.data';
import { getEffectiveSbefGroups } from '@shared/helpers/sbef-scope.helpers';
import { useSelectedSbefGroups } from '@features/sbef/sbef-groups.store';

/** SBEF scope group keys after sanitizing the user's SBEF scope selection. */
export const useEffectiveSbefGroups = (): readonly SbefScopeGroupKey[] => {
  const selectedSbefGroups = useSelectedSbefGroups();
  return useMemo(
    () => getEffectiveSbefGroups(selectedSbefGroups),
    [selectedSbefGroups],
  );
};
